import PropTypes from 'prop-types';
import cx from 'classnames';
import useAnalytics from '../../../../hooks/useAnalytics';
import { productShape } from '../../../../hooks/useAnalytics/useAnalytics.proptypes';
import { useSelector } from 'react-redux';

const ProductLink = ({
  children,
  className,
  handleProductClick,
  link,
  productClickDetails,
  gaListName
}) => {
  const dealerStore = useSelector(s => s.common?.storeLocationName) ?? '';
  const { fireProductClickEvent } = useAnalytics();

  const products = Array.isArray(productClickDetails)
    ? productClickDetails
    : [productClickDetails];

  const onClick = e => {
    if (handleProductClick) {
      e.preventDefault();
      handleProductClick();
    }
    if (productClickDetails) {
      fireProductClickEvent({
        products,
        list: gaListName ?? '',
        dealerStore
      });
    }
  };
  return link ? (
    <a className={cx(className)} href={link} onClick={onClick}>
      {children}
    </a>
  ) : (
    children
  );
};

ProductLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  handleProductClick: PropTypes.func,
  link: PropTypes.string,
  productClickDetails: PropTypes.oneOfType([
    productShape,
    PropTypes.arrayOf(productShape)
  ]),
  gaListName: PropTypes.string
};

export default ProductLink;
